export const TOAST_CONFIG = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const CAROUSEL_RESPONSIVE_CONFIG = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export function getUppercaseText(str) {
  let result = '';
  for(let i = 0; i < str.length; i++) {
      if (/[A-ZÑ ÁÉÍÓÚ]/g.test(str[i]) && (/[A-ZÑ ÁÉÍÓÚ]/g.test(str[i+1]) || /[A-ZÑ ÁÉÍÓÚ]/g.test(str[i-1]))) {
          result += str[i]
      }
  }
  return result.trim();
}
